import { ReactElement } from 'react';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion';
import { Typography } from '../typography';

interface Information {
	title: string;
	content: string | ReactElement;
}

interface Props {
	information: Information[];
}

export const CustomAccordion: React.FC<Props> = ({ information }) => {
	return (
		<Accordion type="single" collapsible className="relative z-10">
			{information.map(({ title, content }, index) => (
				<AccordionItem key={index} value={String(index)}>
					<AccordionTrigger className="hover:no-underline py-6">
						<Typography
							type="bold-22"
							className="text-left !text-lg md:!text-[20px] !font-bold"
						>
							{title}
						</Typography>
					</AccordionTrigger>
					<AccordionContent>
						<Typography type="regular-16" className="opacity-60">
							{content}
						</Typography>
					</AccordionContent>
				</AccordionItem>
			))}
		</Accordion>
	);
};
